module.exports = __webpack_public_path__ + "images/icons_v2/youth-prevention-0f34f4f5.svg";